import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router';
import TopLogo from '../components/TopLogo';
export default function ResetPas() {
    const [details, setDetails] = useState({ email: "" });
    const [err, setError] = useState("")
    useEffect(() => {
        // document.getElementsByClassName('nav-menu')[0].style.display = 'none'
        // document.getElementsByClassName('navbar')[0].style.display = 'none'
    }, [])
    let navigate = useNavigate();
    const submitHandler = e => {
        let div = document.getElementsByClassName('loadmain')[0];
        e.preventDefault();
        if (details.email.length >= 3) {
            div.style.display='flex';
            axios.post(`${process.env.REACT_APP_API_URL1}/auth/users/reset_password/`, {
                email: details.email,
            }).then(response => {
                div.style.display='none';
                setError({ color: 'green', data: 'Reset Password Link Sent to Your Mail' })
            }).catch(err => {
                console.log(err)
                div.style.display='none';
                setError({ color: 'red', data: 'Enter a valid Email' })
            })
        }
        else { setError({ color: 'red', data: 'Enter Email Feild' }) }

    }
    const styles = {
        backgroundColor: '#e5f4f1',
        borderBottom: ' 2px solid #0052b5',
        transition: '5ms'
    };
    return (
        <div className='signindiv'>
            {/* <TopLogo /> */}
            <img className='fixed' src={require('../IMAGES/background.png')}/>
            <form className='oth' onSubmit={submitHandler}>
                <div className='form-inner'>
                    <div>
                        <center><h2>We will send you a link with instructions <br />to reset your password</h2></center>
                        <br /><br /><br />
                    </div>
                    <div style={{ color: err.color }} className='error'>{err.data}</div>
                    <div className='form-group'>
                        <label htmlfor='email'></label>
                        <input type="text" name='email' id='email' placeholder='Email..' onChange={e => setDetails({ ...details, email: e.target.value })} value={details.email} />
                    </div>
                    <div className='Forgot_password'>
                        <button className='Forgot_password' type='button' onClick={() => navigate('/SignIn')}>
                            back
                        </button>
                    </div>
                    <div className='all'>
                        <button type='submit' className='signupbutton'>
                            Get Reset Mail
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}